<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder">{{ $t('mating.Female') }}</h5>
    <p class="mb-0 text-sm text-green" v-if="localFormData.maleLeased && localFormData.selectedLeaseUBNs.length > 0">{{ $t('mating.Male_leased_from_UBN') }} {{ localFormData.selectedLeaseUBNs.join(', ') }}</p>
    <div class="multisteps-form__content">
      <div class="row mt-3">
        <div class="col-12">
          <div class="mb-4">
            <p class="fw-bold text-sm">{{ $t('mating.Selected_females') }} ({{ selectedFemales.length }})</p>
            <div class="row">
              <div v-for="female in selectedFemales" :key="female.id" class="col-md-6 mb-1">
                <div class="card border  text-sm border-success bg-light" @click="toggleSelect(female)">
                  {{ displayText(female) }}
                  <span 
                    class="text-danger position-absolute top-1 end-0"
                    style="cursor: pointer; font-weight: bold; font-size: 25px; margin-right: 10px;"
                    @click.stop="toggleSelect(female)"
                  >
                    ×
                  </span>
                </div>
              </div>
              <p class="text-danger text-sm" v-if="selectedFemales.length === 0" style="margin-bottom: 2px !important;">
                {{ $t('common.No_female_selected') }}
              </p>
              <p class="text-danger text-sm" v-if="v$.selectedFemaleIds.$error">
                {{ v$.selectedFemaleIds.$errors[0].$message }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-6">
          <!-- Search Input -->
          <div class="input-group input-group-static null">
            <label class="">{{ $t('mating.Search') }}</label>
            <input v-model="searchQuery" type="text" class="form-control form-control-default" :placeholder="$t('mating.Search_UBN_studbooknumber_animalnumber_name')"> 
          </div>
        </div>
        <div class="col-12 mt-3">
          <!-- Available Females -->
          <p class="fw-bold text-sm">{{ $t('mating.Available_females') }}</p>
          <div class="row">
            <div v-for="female in filteredFemales" :key="female.id" class="col-md-6 mb-1">
              <div class="card border text-sm" :class="{ 'border-success bg-light': isSelected(female.id), 'cursor-pointer': true }" @click="toggleSelect(female)">
                {{ displayText(female) }}
              </div>
            </div>
          </div>
        </div>
      </div>      
      <!--div class="button-row d-flex mt-4">
        <button class="btn mb-0 bg-gradient-light btn-sm null null js-btn-prev" type="button" @click="validateAndPrevStep">{{ $t('common.Prev') }}</button>        
      </div -->
      <div class="button-row d-flex mt-4">
        <button class="btn mb-0 bg-gradient-light btn-sm me-2" type="button" @click="validateAndPrevStep">
          {{ $t('common.Prev') }}
        </button>

        <button class="btn mb-0 btn-sm bg-gradient-success ms-auto" type="button" :disabled="!canSave"
            :title="!canSave ? $t('common.Select_at_least_one_female') : ''" @click="onSaveClick">
          {{ $t('common.Save') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { computed, reactive, ref, watch } from 'vue'
  import { required, helpers } from '@vuelidate/validators'
  import useVuelidate from '@vuelidate/core'
  import { useI18n } from 'vue-i18n'

  export default {
    name: "MatingFemale",
    props: {
      females: Array,
      formData: Object,
      prevStep: Function,
      saveForm: { 
        type: Function,
        required: true
      }
    },
    setup(props, { emit }) {
      const { t } = useI18n()
      const localFormData = reactive({ ...props.formData })
      
      const searchQuery = ref('')
      const selectedFemaleIds = ref(
        String(props.formData.females || '').split(',').filter(id => id)
      )

      const isSelected = (id) => selectedFemaleIds.value.includes(id)

      const toggleSelect = (female) => {
        const index = selectedFemaleIds.value.indexOf(female.id)
        if (index > -1) {
          selectedFemaleIds.value.splice(index, 1)
        } else {
          selectedFemaleIds.value.push(female.id)
        }
      }

      const displayText = (f) =>
        `${f.studbookNumber} ${f.animalNumber ? ` | ${f.animalNumber}` : ''}${f.name ? ` (${f.name})` : ''} ${f.inbreedFactor ? ` | ${f.inbreedFactor}` : ''}`

      const selectedFemales = computed(() =>
        props.females.filter(f => selectedFemaleIds.value.includes(f.id))
      )

      const filteredFemales = computed(() =>
        props.females.filter(f =>
          !selectedFemaleIds.value.includes(f.id) &&
          displayText(f).toLowerCase().includes(searchQuery.value.toLowerCase())
        )
      )

      // Vuelidate rules – require at least one selected female
      const rules = computed(() => ({
        selectedFemaleIds: {
          required: helpers.withMessage(t('common.Select_at_least_one_female'), required),
          minOne: helpers.withMessage(t('common.Select_at_least_one_female'), value => value.length > 0)
        }
      }))
      
      const v$ = useVuelidate(rules, { selectedFemaleIds })

      watch(localFormData, () => {
        emit('update:formData', localFormData)
      }, { deep: true })

      const validateAndPrevStep = async () => {
        if (selectedFemales.value.length > 0) {
          props.prevStep();
          return;
        }

        v$.value.$touch()
        if (v$.value.$pending) {
          await v$.value.$validate()
        }
        if (!v$.value.$invalid) {
          localFormData.femaleIds = selectedFemaleIds.value          
          props.prevStep()
        }
      }

      const validateAndSubmit = async () => {
        v$.value.$touch()
        const isValid = await v$.value.$validate()
        if (!isValid) return false
        localFormData.femaleIds = selectedFemaleIds.value.join(',')
        Object.assign(props.formData, localFormData)
        return true        
      };

      const canSave = computed(() =>
        selectedFemales.value.length > 0 && !(v$.value?.selectedFemaleIds?.$error)
      )

      const onSaveClick = async () => {
        const ok = await validateAndSubmit()
        if (!ok) return      
        props.saveForm()
      }

      return {
        localFormData,
        searchQuery,
        selectedFemaleIds,
        selectedFemales,
        filteredFemales,
        isSelected,
        toggleSelect,
        displayText,
        v$,
        validateAndPrevStep,
        validateAndSubmit,
        canSave,
        onSaveClick
      }
    }    
};
</script>
<style scoped>
  .card {
    transition: background-color 0.2s ease-in-out;
    cursor: pointer;
    padding: 10px !important;
  }
</style>